// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { connect } from "react-redux";

import { logout } from "src/actions";

import {
  ParaLink,
  ParaContainer,
  ParaHeader,
  ParaFooter,
  ParaBody,
} from "src/styles/signup";

type Props = {
  logout: Function,
};

const EmailNotVerified = ({ logout }: Props) => (
  <ParaContainer>
    <ParaHeader>{i18n.t(k.LOOKS_LIKE_YOUR_EMAIL_IS_NOT_V)}</ParaHeader>
    <ParaBody>{i18n.t(k.AN_EMAIL_HAS_BEEN_SENT_TO_YOUR)}</ParaBody>
    <ParaFooter>
      <ParaLink onClick={() => logout()}>{i18n.t(k.CANCEL)}</ParaLink>
    </ParaFooter>
    <ParaFooter>
      {i18n.t(k.STILL_HAVING_TROUBLES)}{" "}
      <ParaLink
        href="https://www.unifize.com/about-us/#contact-us"
        target="_blank"
      >
        {i18n.t(k.CONTACT_US)}
      </ParaLink>
    </ParaFooter>
  </ParaContainer>
);

export default connect(null, {
  logout,
})(EmailNotVerified);
